const ProgressBar = ({ completed, total }) => {
  return (
    <div className="relative h-full bg-sky-200">
      <div
        className="absolute top-0 left-0 h-full bg-sky-500"
        style={{ width: `${(100 * completed) / total}%` }}
      ></div>
      <div className="flex justify-center items-center h-full">
        <span style={{zIndex: 1}}>
          {completed} / {total}
        </span>
      </div>
    </div>
  );
};

export default ProgressBar;
